module.exports = __webpack_public_path__ + "static/media/wish-you-where-here.82eb525b.jpg";